import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, Options} from "../utils/decorators";
import {each} from "jquery";

@Options({
    template: false,
})
export default class ShuttleSelection extends Marionette.View<Backbone.Model> {
    constructor(options?: object) {
        super(options);

        this.createSelect();
    }

    createSelect() {
        let performanceSwitcher = this.$el.get(0);
        let availablePerformances = performanceSwitcher.dataset.relatedPerformances;
        let defaultValue = performanceSwitcher.dataset.defaultValue;

        if (availablePerformances) {
            availablePerformances = JSON.parse(availablePerformances);
        }

        if (!defaultValue) {
            performanceSwitcher.appendChild(this.createSelectOption({
                id: 0,
                name: 'Select performance',
            }, 0))
        }

        each(availablePerformances, (idx, option) => {
            performanceSwitcher.appendChild(this.createSelectOption(option, defaultValue))
        })
    }

    createSelectOption(optionDetails, defaultValue) {
        const option = document.createElement('option');

        option.value = optionDetails.id;
        option.textContent = optionDetails.name

        if (optionDetails.url) {
            option.dataset.url = optionDetails.url;
        }

        if (parseInt(optionDetails.id) === parseInt(defaultValue)) {
            option.selected = true;
        }

        return option;
    }

    onRender() {
        if (this.$el.get(0)) {
            $(this.$el).on('select2:select', function (e) {
                let self = this as HTMLSelectElement;
                window.location.replace(self.options[self.selectedIndex].dataset.url);
            });
        }
    }
}




// WEBPACK FOOTER //
// ./@modules/views/shuttle-selection.ts